// extracted by mini-css-extract-plugin
export var cardHeader = "_en-0";
export var reorderHandle = "_en-3";
export var titleArea = "_en-1";
export var titleAreaWithHandle = "_en-2";